import React from "react"
import { CourseState } from "../../Course/CourseState"
import { useCourseStore } from "../../Course/CourseStore"
import { useNoteNames } from "../../Project/ProjectStore"
import { Menu, MenuItem, MenuRadioGroup } from "@szhsin/react-menu"
import { MenuArrow } from "../Menu/MenuDownArrow"
export interface NotesSelectProps{
    tonic:number
    onChange:Function
    title?:string
    initialOptionTitle?:string
    hideLabel?:boolean
}
export function NotesSelect(props:NotesSelectProps):JSX.Element{
  return(<NotesSelectMenu tonic={props.tonic} onChange={props.onChange}/>)
    /* let options:JSX.Element[] = []
    if(props.tonic === -1){
      let optionTitle:string = ''
      if(props.initialOptionTitle) optionTitle = props.initialOptionTitle
      options.push(<option value={-1} key={-1}>{optionTitle}</option>)
    }
    const notes:string[] = useNoteNames()
    const getTitle = () => {
      if(props.hideLabel) return ''
      const title:string = (props.title) ? props.title : 'Select a Key'
      return title + ": "
    }
    notes.forEach((note:string, index:number) => {
      let o:JSX.Element = <option value={index} key={index}>{note}</option>
      options.push(o)
    })
    const onChange = (e:any) => {
      if(e.currentTarget.value !== -1){
        props.onChange(parseInt(e.currentTarget.value))
      }
    }
    return <div className="key-select"><span className='bold'>{getTitle()}</span>
              <select className='note-select' 
                      onClick={(e:React.MouseEvent)=>{e.stopPropagation()}} 
                      value={props.tonic} onChange={onChange}>
                {options}
              </select>
            </div> */
  }

export function NotesSelectMenu(props:NotesSelectProps):JSX.Element{
    const noteNames:string[] = useNoteNames()
    return(
      <Menu menuButton={<button type='button'>Select Key: <div style={{width:25, display:'inline-block', fontWeight:'bold'}}>{noteNames[props.tonic]}</div> <MenuArrow/></button>}>
        <MenuRadioGroup value={props.tonic} onRadioChange={(e:any)=>{props.onChange(e.value)}}>                   
        {
          noteNames.map((noteName:string, index:number)=>{
            return(<MenuItem key={index} type="radio" value={index}>{noteName}</MenuItem>)
          })
        }
        </MenuRadioGroup>
      </Menu>
    )
}
